import React, { useMemo } from "react";
import { useGetMenusDataQuery } from "../../redux/services/internal/apiHome";
import Spinner from "../Container/Components/Spinner";
import { Link } from "react-router-dom";
import Loader from "../Container/Components/Loader";

const SideBarTopLinks = ({ benchId }) => {
  const { data: fetchMenus = {}, isLoading: isMenuLoading } =
    useGetMenusDataQuery(benchId, {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      skip: !benchId,
    });

  const aboutMenuLinks = useMemo(() => {
    const aboutMenuData = fetchMenus?.data?.[0];
    if (aboutMenuData?.title === "About Us") {
      return [...aboutMenuData.sub_pages].sort(
        (a, b) => a.short_id - b.short_id
      );
    }
    return [];
  }, [fetchMenus]);

  if (isMenuLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="about-links">
        <div className="titlesec">
          <h4 className="httxt">About Us</h4>
        </div>
        <div className="title-links">
          <ul>
            {isMenuLoading ? (
              <div style={{ height: "400px" }}>
                <Spinner />
              </div>
            ) : (
              <>
                {aboutMenuLinks.length > 0 ? (
                  aboutMenuLinks.map((menu, index) => (
                    <li className="nav-item" key={index}>
                      <Link className="nav-link lnk-arrow" to={menu.slug}>
                        {menu.title}
                        <i className="fa-solid fa-chevron-right"></i>
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="nav-item">
                    <a className="nav-link lnk-arrow" href="#">
                      No data Found
                    </a>
                  </li>
                )}
                <li>
                  <Link to="calendar-detail" className="lnk-arrow">
                    Calendar
                    <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideBarTopLinks;
